import type { PropsOf } from '@emotion/react';
import styled from '@emotion/styled';
import { DatePicker, SelectInput, type SelectOption, Text } from '@innovationdepartment/proxima-ui';
import type { MetaAdAccount } from 'types/stores/ad-account-store';

type FacebookTableSearchFilterProps = {
  adAccounts: SelectOption[];
  metaAdAccount: MetaAdAccount | null;
  onAdAccountChange: (adAccountId: string) => void;
  dateRange: PropsOf<typeof DatePicker>['dateRange'];
  onDateRangeChange: PropsOf<typeof DatePicker>['onDateRangeSelect'];
};

const SearchFilterWrapper = styled.div`
  display: flex;
  margin: 16px 0 8px;
  justify-content: flex-end;
`;

const SearchFilterAdAccountSelectWrapper = styled.div`
  margin-right: 8px;
  display: flex;
  gap: 8px;
  align-items: center;

  * [class*='MuiInputBase'] {
    background-color: white;
  }
`;

const FacebookTableSearchFilterView: React.FC<FacebookTableSearchFilterProps> = props => {
  const { dateRange, onDateRangeChange, onAdAccountChange, adAccounts, metaAdAccount } = props;
  return (
    <SearchFilterWrapper>
      <SearchFilterAdAccountSelectWrapper>
        <Text variant="body2Semibold">Ad Account:</Text>
        <SelectInput
          options={adAccounts}
          value={metaAdAccount?.adAccountId}
          onChange={onAdAccountChange}
        />
      </SearchFilterAdAccountSelectWrapper>
      <DatePicker disableFutureDates dateRange={dateRange} onDateRangeSelect={onDateRangeChange} />
    </SearchFilterWrapper>
  );
};

export default FacebookTableSearchFilterView;
